import { render, staticRenderFns } from "./InventorySettings.vue?vue&type=template&id=c1e24aba&scoped=true&"
import script from "./InventorySettings.vue?vue&type=script&lang=js&"
export * from "./InventorySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e24aba",
  null
  
)

export default component.exports